var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mb-4 px-4 mt-4 overflow-x-scroll fix-scrollbar",
      class: _vm.getheight,
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-col h-auto overflow-x-scroll p-2 fix-scrollbar",
        },
        [
          _c("div", { staticClass: "flex-grow overflow-auto scrollbar" }, [
            _c(
              "div",
              {
                staticClass:
                  "relative w-full text-sm text-bold text-left dark:text-gray-400",
              },
              _vm._l(_vm.documents, function (document) {
                return _c(
                  "div",
                  {
                    key: document.id,
                    staticClass:
                      "text-black hover:bg-gray-50 dark:hover:bg-gray-600 flex flex-row gap-4 p-2 mb-2 bg-snow-white sm:rounded-lg",
                  },
                  [
                    _c(
                      "div",
                      [
                        document.filename.split(".")[1] === "pdf"
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "34",
                                    height: "40",
                                    viewBox: "0 0 34 40",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("g", { attrs: { opacity: "0.3" } }, [
                                    _c("path", {
                                      attrs: {
                                        opacity: "0.3",
                                        d: "M23.2774 8.208C22.3661 8.20712 21.4923 7.84483 20.8478 7.20059C20.2032 6.55636 19.8405 5.68278 19.8392 4.77147V0H4.48481C3.29536 0 2.15465 0.472504 1.31359 1.31357C0.47252 2.15464 0 3.29537 0 4.48481V31.5204C0 32.7098 0.47252 33.8506 1.31359 34.6916C2.15465 35.5327 3.29536 36.0052 4.48481 36.0052H22.9174C24.1069 36.0052 25.2476 35.5327 26.0887 34.6916C26.9297 33.8506 27.4022 32.7098 27.4022 31.5204V8.208H23.2774Z",
                                        fill: "#FF3E4C",
                                      },
                                    }),
                                  ]),
                                  _c("path", {
                                    attrs: {
                                      d: "M27.3974 8.208H23.2725C22.3612 8.20712 21.4875 7.84483 20.8429 7.20059C20.1984 6.55636 19.8357 5.68278 19.8344 4.77147V0L27.3974 8.208Z",
                                      fill: "#FF3E4C",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M21.7614 25.1373H4.5554C4.39544 25.129 4.24477 25.0597 4.13447 24.9435C4.02418 24.8274 3.96265 24.6733 3.96265 24.5132C3.96265 24.353 4.02418 24.1989 4.13447 24.0828C4.24477 23.9666 4.39544 23.8973 4.5554 23.889H21.7614C21.846 23.8846 21.9307 23.8975 22.0103 23.9269C22.0898 23.9563 22.1625 24.0016 22.224 24.06C22.2855 24.1184 22.3344 24.1886 22.3679 24.2666C22.4013 24.3445 22.4186 24.4284 22.4186 24.5132C22.4186 24.5979 22.4013 24.6819 22.3679 24.7598C22.3344 24.8377 22.2855 24.908 22.224 24.9663C22.1625 25.0247 22.0898 25.07 22.0103 25.0994C21.9307 25.1288 21.846 25.1417 21.7614 25.1373V25.1373Z",
                                      fill: "#FF3E4C",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M21.7614 18.0992H4.5554C4.39544 18.0909 4.24477 18.0216 4.13447 17.9054C4.02418 17.7893 3.96265 17.6352 3.96265 17.4751C3.96265 17.3149 4.02418 17.1608 4.13447 17.0447C4.24477 16.9286 4.39544 16.8592 4.5554 16.8509H21.7614C21.846 16.8466 21.9307 16.8595 22.0103 16.8888C22.0898 16.9182 22.1625 16.9635 22.224 17.0219C22.2855 17.0803 22.3344 17.1506 22.3679 17.2285C22.4013 17.3064 22.4186 17.3903 22.4186 17.4751C22.4186 17.5599 22.4013 17.6438 22.3679 17.7217C22.3344 17.7996 22.2855 17.8699 22.224 17.9283C22.1625 17.9866 22.0898 18.0319 22.0103 18.0613C21.9307 18.0907 21.846 18.1036 21.7614 18.0992V18.0992Z",
                                      fill: "#FF3E4C",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M21.7614 21.6183H4.5554C4.39544 21.61 4.24477 21.5406 4.13447 21.4245C4.02418 21.3083 3.96265 21.1543 3.96265 20.9941C3.96265 20.8339 4.02418 20.6799 4.13447 20.5637C4.24477 20.4476 4.39544 20.3782 4.5554 20.37H21.7614C21.846 20.3656 21.9307 20.3785 22.0103 20.4079C22.0898 20.4373 22.1625 20.4825 22.224 20.5409C22.2855 20.5993 22.3344 20.6696 22.3679 20.7475C22.4013 20.8254 22.4186 20.9093 22.4186 20.9941C22.4186 21.0789 22.4013 21.1628 22.3679 21.2407C22.3344 21.3186 22.2855 21.3889 22.224 21.4473C22.1625 21.5057 22.0898 21.551 22.0103 21.5803C21.9307 21.6097 21.846 21.6226 21.7614 21.6183V21.6183Z",
                                      fill: "#FF3E4C",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M14.9749 14.5803H4.5554C4.39544 14.572 4.24477 14.5027 4.13447 14.3865C4.02418 14.2704 3.96265 14.1163 3.96265 13.9562C3.96265 13.796 4.02418 13.6419 4.13447 13.5258C4.24477 13.4097 4.39544 13.3403 4.5554 13.332H14.9749C15.1349 13.3403 15.2856 13.4097 15.3959 13.5258C15.5062 13.6419 15.5677 13.796 15.5677 13.9562C15.5677 14.1163 15.5062 14.2704 15.3959 14.3865C15.2856 14.5027 15.1349 14.572 14.9749 14.5803V14.5803Z",
                                      fill: "#FF3E4C",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M14.9749 11.0613H4.5554C4.39544 11.053 4.24477 10.9836 4.13447 10.8675C4.02418 10.7514 3.96265 10.5973 3.96265 10.4371C3.96265 10.277 4.02418 10.1229 4.13447 10.0068C4.24477 9.89062 4.39544 9.82126 4.5554 9.81299H14.9749C15.1349 9.82126 15.2856 9.89062 15.3959 10.0068C15.5062 10.1229 15.5677 10.277 15.5677 10.4371C15.5677 10.5973 15.5062 10.7514 15.3959 10.8675C15.2856 10.9836 15.1349 11.053 14.9749 11.0613Z",
                                      fill: "#FF3E4C",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M30.6616 28.4336H9.82244C8.34422 28.4336 7.14587 29.6319 7.14587 31.1102V37.3232C7.14587 38.8015 8.34422 39.9998 9.82244 39.9998H30.6616C32.1398 39.9998 33.3382 38.8015 33.3382 37.3232V31.1102C33.3382 29.6319 32.1398 28.4336 30.6616 28.4336Z",
                                      fill: "#FF3E4C",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M13.9755 35.5615V36.7731H12.7206V35.5615H13.9755Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M15.8133 35.0159V36.7742H14.6V31.7627H16.5632C17.1599 31.7627 17.6138 31.9105 17.9249 32.206C18.0828 32.3609 18.2061 32.5474 18.2868 32.7534C18.3676 32.9593 18.4038 33.18 18.3932 33.401C18.3986 33.6925 18.3261 33.9802 18.1832 34.2343C18.039 34.4839 17.823 34.6843 17.5632 34.8092C17.2512 34.9574 16.9084 35.0288 16.5632 35.0176L15.8133 35.0159ZM17.1599 33.401C17.1599 32.9565 16.9165 32.7343 16.4299 32.7343H15.8133V34.0393H16.4299C16.9165 34.0437 17.1599 33.8309 17.1599 33.401V33.401Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M23.1916 35.5648C22.9823 35.9439 22.6665 36.2533 22.2833 36.4548C21.8532 36.6752 21.3748 36.7847 20.8917 36.7731H18.9984V31.7616H20.8917C21.3757 31.7498 21.8552 31.8569 22.2883 32.0733C22.6695 32.2712 22.9837 32.5773 23.1916 32.9532C23.3987 33.3574 23.5067 33.8049 23.5067 34.259C23.5067 34.7131 23.3987 35.1607 23.1916 35.5648V35.5648ZM21.8866 35.3131C22.1404 35.0199 22.2801 34.6451 22.2801 34.2573C22.2801 33.8696 22.1404 33.4948 21.8866 33.2016C21.5836 32.9354 21.1875 32.8 20.785 32.8249H20.21V35.6881H20.7933C21.1928 35.7107 21.5852 35.5761 21.8866 35.3131V35.3131Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M27.4508 31.7627V32.7277H25.3958V33.8259H26.9841V34.7476H25.3958V36.7742H24.1842V31.7627H27.4508Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M21.4634 9.81299H18.5169C18.0033 9.81299 17.5869 10.2293 17.5869 10.743V13.6895C17.5869 14.2031 18.0033 14.6195 18.5169 14.6195H21.4634C21.977 14.6195 22.3934 14.2031 22.3934 13.6895V10.743C22.3934 10.2293 21.977 9.81299 21.4634 9.81299Z",
                                      fill: "#FF3E4C",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        document.filename.split(".")[1] === "jpg" ||
                        document.filename.split(".")[1] === "jpeg"
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "34",
                                    height: "40",
                                    viewBox: "0 0 34 40",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("g", { attrs: { opacity: "0.3" } }, [
                                    _c("path", {
                                      attrs: {
                                        opacity: "0.3",
                                        d: "M23.2782 8.20828C22.3665 8.2074 21.4925 7.84487 20.8479 7.20025C20.2033 6.55563 19.8408 5.68159 19.8399 4.76997V0H4.48496C3.29547 0 2.15468 0.472515 1.31359 1.31361C0.472495 2.15471 0 3.29547 0 4.48496V31.5148C0 32.1038 0.115997 32.687 0.341388 33.2311C0.566779 33.7752 0.897122 34.2697 1.31359 34.6861C1.73006 35.1026 2.22448 35.433 2.76862 35.6584C3.31276 35.8837 3.89598 35.9998 4.48496 35.9998H22.9182C24.1077 35.9998 25.2484 35.5272 26.0895 34.6861C26.9306 33.845 27.4031 32.7043 27.4031 31.5148V8.20828H23.2782Z",
                                        fill: "#00C650",
                                      },
                                    }),
                                  ]),
                                  _c("path", {
                                    attrs: {
                                      d: "M27.4034 8.20828H23.2784C22.3668 8.2074 21.4927 7.84487 20.8481 7.20025C20.2035 6.55563 19.841 5.68159 19.8401 4.76997V0L27.4034 8.20828Z",
                                      fill: "#00C650",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M30.6572 28.4336H9.81728C8.33901 28.4336 7.14062 29.632 7.14062 31.1102V37.3235C7.14062 38.8018 8.33901 40.0002 9.81728 40.0002H30.6572C32.1354 40.0002 33.3338 38.8018 33.3338 37.3235V31.1102C33.3338 29.632 32.1354 28.4336 30.6572 28.4336Z",
                                      fill: "#00C650",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M14.0361 35.563V36.7747H12.7811V35.563H14.0361Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M17.7591 31.7634V35.1817C17.7591 35.7073 17.6164 36.1111 17.3308 36.3934C17.1717 36.5409 16.9844 36.6547 16.7802 36.728C16.576 36.8014 16.3591 36.8326 16.1425 36.82C15.9053 36.8326 15.6679 36.798 15.4442 36.7182C15.2205 36.6383 15.0149 36.5149 14.8392 36.355C14.517 36.045 14.3558 35.6006 14.3558 35.0217H15.5542C15.5542 35.4895 15.7314 35.7234 16.0858 35.7234C16.3925 35.7234 16.5475 35.545 16.5475 35.185V31.7617L17.7591 31.7634Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M19.7723 35.015V36.7734H18.5607V31.7617H20.529C21.124 31.7617 21.5773 31.9084 21.889 32.2051C22.0468 32.3597 22.1701 32.546 22.2508 32.7516C22.3315 32.9573 22.3678 33.1777 22.3573 33.3984C22.3619 33.6896 22.29 33.9769 22.149 34.2317C22.0033 34.4807 21.7869 34.6808 21.5273 34.8067C21.215 34.9539 20.8724 35.0253 20.5273 35.015H19.7723ZM21.119 33.3984C21.119 32.9606 20.8756 32.7384 20.389 32.7317H19.7723V34.035H20.389C20.8756 34.0417 21.119 33.8301 21.119 33.4001V33.3984Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M26.8471 32.1808C27.2501 32.4847 27.5214 32.9314 27.6054 33.4291H26.3221C26.2383 33.2502 26.1023 33.1009 25.9321 33.0008C25.6836 32.8649 25.3977 32.8135 25.1175 32.8544C24.8373 32.8953 24.578 33.0262 24.3788 33.2274C24.1349 33.5192 24.011 33.8927 24.0321 34.2724C24.0321 34.7507 24.1538 35.1157 24.3971 35.3707C24.5337 35.5038 24.6967 35.6066 24.8756 35.6727C25.0544 35.7387 25.2451 35.7664 25.4354 35.7541C25.7081 35.759 25.975 35.6747 26.1954 35.5141C26.4204 35.3455 26.5828 35.1069 26.6571 34.8357H25.1254V33.9641H27.6704V35.1624C27.5725 35.4604 27.4186 35.7371 27.2171 35.9774C26.9984 36.2363 26.726 36.4444 26.4188 36.5874C26.0719 36.7485 25.6928 36.8283 25.3104 36.8207C24.8454 36.8329 24.3854 36.722 23.9771 36.4991C23.604 36.2892 23.3 35.9753 23.1021 35.5957C22.8989 35.1833 22.7932 34.7297 22.7932 34.2699C22.7932 33.8101 22.8989 33.3565 23.1021 32.9441C23.2992 32.565 23.602 32.2513 23.9737 32.0408C24.3759 31.8189 24.8296 31.7073 25.2888 31.7174C25.8452 31.6947 26.3934 31.8577 26.8471 32.1808V32.1808Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M17.3839 24.402H10.029C9.30832 24.4012 8.61742 24.1145 8.10782 23.6049C7.59823 23.0953 7.31155 22.4044 7.31067 21.6837V14.3221C7.31155 13.6016 7.59831 12.9109 8.10795 12.4015C8.61759 11.8922 9.30848 11.6059 10.029 11.6055H17.3906C18.1108 11.6064 18.8013 11.8928 19.3106 12.4021C19.8199 12.9114 20.1064 13.6019 20.1073 14.3221V21.6821C20.1073 22.0395 20.0368 22.3935 19.8999 22.7237C19.763 23.0539 19.5623 23.354 19.3094 23.6066C19.0565 23.8592 18.7563 24.0595 18.4259 24.196C18.0955 24.3325 17.7414 24.4025 17.3839 24.402V24.402ZM10.029 12.8071C9.62718 12.8076 9.24192 12.9673 8.95763 13.2512C8.67335 13.5352 8.5132 13.9203 8.51232 14.3221V21.6821C8.51276 22.0842 8.67273 22.4697 8.95706 22.754C9.24139 23.0383 9.62689 23.1983 10.029 23.1987H17.3906C17.7924 23.1978 18.1775 23.0377 18.4615 22.7534C18.7454 22.4691 18.9052 22.0839 18.9056 21.6821V14.3204C18.9052 13.9188 18.7454 13.5337 18.4614 13.2497C18.1774 12.9656 17.7923 12.8059 17.3906 12.8055L10.029 12.8071Z",
                                      fill: "#00C650",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M19.4996 20.2836V21.6836C19.4996 22.2449 19.2766 22.7833 18.8796 23.1802C18.4827 23.5772 17.9443 23.8002 17.3829 23.8002H10.028C9.74988 23.8004 9.47448 23.7458 9.21748 23.6396C8.96048 23.5333 8.72691 23.3774 8.53019 23.1808C8.33346 22.9843 8.1774 22.7509 8.07092 22.494C7.96445 22.237 7.90967 21.9617 7.90967 21.6836V19.3369C9.08966 19.0836 10.8846 19.0036 13.063 19.8752L14.413 18.5869L15.333 20.9202C15.333 20.9202 15.5796 20.0619 16.3763 20.1836C17.1729 20.3052 18.4629 20.7369 19.0146 20.3686C19.1609 20.2833 19.333 20.2531 19.4996 20.2836V20.2836Z",
                                      fill: "#00C650",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M16.9215 15.8251C17.3734 15.8251 17.7398 15.4587 17.7398 15.0068C17.7398 14.5548 17.3734 14.1885 16.9215 14.1885C16.4695 14.1885 16.1031 14.5548 16.1031 15.0068C16.1031 15.4587 16.4695 15.8251 16.9215 15.8251Z",
                                      fill: "#00C650",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        document.filename.split(".")[1] === "png"
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "34",
                                    height: "40",
                                    viewBox: "0 0 34 40",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("g", { attrs: { opacity: "0.3" } }, [
                                    _c("path", {
                                      attrs: {
                                        opacity: "0.3",
                                        d: "M23.2782 8.20828C22.3669 8.20695 21.4933 7.84423 20.849 7.19966C20.2048 6.55509 19.8424 5.6813 19.8416 4.76997V3.097e-07H4.48669C3.89757 -0.000218611 3.31416 0.115627 2.76982 0.34092C2.22549 0.566213 1.73087 0.896531 1.31423 1.31302C0.897581 1.72951 0.567071 2.224 0.341576 2.76825C0.11608 3.3125 2.5047e-05 3.89584 2.50877e-05 4.48496V31.5148C-0.00194947 32.1052 0.112651 32.6901 0.337262 33.2361C0.561873 33.7821 0.892094 34.2783 1.30894 34.6964C1.72578 35.1145 2.22105 35.4462 2.76636 35.6724C3.31168 35.8986 3.89631 36.015 4.48669 36.0148H22.9199C24.1094 36.0148 25.2501 35.5422 26.0912 34.7011C26.9323 33.86 27.4049 32.7193 27.4049 31.5298V8.20828H23.2782Z",
                                        fill: "#005FAD",
                                      },
                                    }),
                                  ]),
                                  _c("path", {
                                    attrs: {
                                      d: "M27.4052 8.20828H23.2786C22.3672 8.20695 21.4936 7.84423 20.8494 7.19966C20.2051 6.55509 19.8428 5.6813 19.8419 4.76997V0L27.4052 8.20828Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M30.6571 28.4336H9.81728C8.33901 28.4336 7.14062 29.632 7.14062 31.1102V37.3235C7.14062 38.8018 8.33901 40.0002 9.81728 40.0002H30.6571C32.1354 40.0002 33.3338 38.8018 33.3338 37.3235V31.1102C33.3338 29.632 32.1354 28.4336 30.6571 28.4336Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M13.1767 35.563V36.7747H11.9218V35.563H13.1767Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M15.0206 35.015V36.7734H13.809V31.7617H15.7723C16.3673 31.7617 16.8206 31.9084 17.1323 32.2051C17.2901 32.3597 17.4134 32.546 17.4941 32.7516C17.5748 32.9573 17.6111 33.1777 17.6006 33.3984C17.6052 33.6896 17.5333 33.9769 17.3923 34.2317C17.2466 34.4807 17.0302 34.6808 16.7706 34.8067C16.4583 34.9539 16.1157 35.0253 15.7706 35.015H15.0206ZM16.3673 33.3984C16.3673 32.9606 16.1239 32.7384 15.6373 32.7317H15.0206V34.035H15.6373C16.1239 34.0417 16.3673 33.8301 16.3673 33.4001V33.3984Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M22.6468 36.7753H21.4352L19.4085 33.6987V36.7753H18.1952V31.7637H19.4085L21.4352 34.8687V31.7637H22.6468V36.7753Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M27.3853 32.1812C27.7893 32.4844 28.0614 32.9313 28.1453 33.4295H26.862C26.7782 33.2506 26.6422 33.1013 26.4719 33.0012C26.2235 32.8653 25.9376 32.8139 25.6574 32.8548C25.3772 32.8957 25.1179 33.0266 24.9186 33.2278C24.6748 33.5196 24.5509 33.8931 24.572 34.2728C24.572 34.7512 24.6936 35.1161 24.937 35.3711C25.0735 35.5042 25.2365 35.607 25.4154 35.6731C25.5943 35.7391 25.785 35.7668 25.9753 35.7545C26.2471 35.76 26.5132 35.6769 26.7336 35.5178C26.9586 35.3493 27.121 35.1106 27.1953 34.8395H25.6636V33.9678H28.2086V35.1661C28.1107 35.4642 27.9569 35.7408 27.7553 35.9811C27.5366 36.24 27.2642 36.4482 26.9569 36.5911C26.6101 36.7523 26.231 36.8321 25.8486 36.8245C25.3836 36.8367 24.9236 36.7257 24.5153 36.5028C24.1422 36.2929 23.8382 35.9791 23.6403 35.5995C23.4371 35.187 23.3314 34.7334 23.3314 34.2737C23.3314 33.8139 23.4371 33.3603 23.6403 32.9478C23.8374 32.5688 24.1402 32.255 24.512 32.0445C24.914 31.8224 25.3677 31.7108 25.8269 31.7212C26.3831 31.6967 26.9315 31.8586 27.3853 32.1812V32.1812Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M9.11624 11.1201H6.82458V13.4118H9.11624V11.1201Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M11.4105 13.4121H9.1189V15.7038H11.4105V13.4121Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M13.7013 11.1201H11.4097V13.4118H13.7013V11.1201Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M15.9929 13.4121H13.7013V15.7038H15.9929V13.4121Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M18.2854 11.1201H15.9938V13.4118H18.2854V11.1201Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M20.5806 13.4121H18.2889V15.7038H20.5806V13.4121Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M9.11624 15.7002H6.82458V17.9918H9.11624V15.7002Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M11.4105 17.9912H9.1189V20.2829H11.4105V17.9912Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M13.7013 15.7002H11.4097V17.9918H13.7013V15.7002Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M15.9929 17.9912H13.7013V20.2829H15.9929V17.9912Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M18.2854 15.7002H15.9938V17.9918H18.2854V15.7002Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M20.5806 17.9912H18.2889V20.2829H20.5806V17.9912Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M9.11624 20.3018H6.82458V22.5934H9.11624V20.3018Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M11.4105 22.5928H9.1189V24.8844H11.4105V22.5928Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M13.7013 20.3018H11.4097V22.5934H13.7013V20.3018Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M15.9929 22.5928H13.7013V24.8844H15.9929V22.5928Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M18.2854 20.3018H15.9938V22.5934H18.2854V20.3018Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M20.5806 22.5928H18.2889V24.8844H20.5806V22.5928Z",
                                      fill: "#005FAD",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        document.filename.split(".")[1] === "docx" ||
                        document.filename.split(".")[1] === "doc"
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "34",
                                    height: "40",
                                    viewBox: "0 0 34 40",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("g", { attrs: { opacity: "0.3" } }, [
                                    _c("path", {
                                      attrs: {
                                        opacity: "0.3",
                                        d: "M23.2775 8.20804C22.3662 8.20715 21.4924 7.84486 20.8479 7.20062C20.2033 6.55638 19.8406 5.6828 19.8393 4.77149V0H4.48482C3.29537 0 2.15462 0.472506 1.31355 1.31358C0.472481 2.15465 0 3.29538 0 4.48483V31.5205C0 32.71 0.472481 33.8507 1.31355 34.6918C2.15462 35.5329 3.29537 36.0054 4.48482 36.0054H22.9175C24.107 36.0054 25.2477 35.5329 26.0887 34.6918C26.9298 33.8507 27.4023 32.71 27.4023 31.5205V8.20804H23.2775Z",
                                        fill: "#0072FF",
                                      },
                                    }),
                                  ]),
                                  _c("path", {
                                    attrs: {
                                      d: "M27.4034 8.20804H23.2785C22.3672 8.20715 21.4935 7.84486 20.8489 7.20062C20.2044 6.55638 19.8417 5.6828 19.8403 4.77149V0L27.4034 8.20804Z",
                                      fill: "#0072FF",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M21.7641 13.9542H4.55804C4.39809 13.9459 4.24741 13.8766 4.13712 13.7604C4.02682 13.6443 3.96533 13.4902 3.96533 13.3301C3.96533 13.1699 4.02682 13.0158 4.13712 12.8997C4.24741 12.7835 4.39809 12.7142 4.55804 12.7059H21.7641C21.8488 12.7015 21.9334 12.7144 22.013 12.7438C22.0925 12.7732 22.1652 12.8185 22.2267 12.8769C22.2882 12.9353 22.3372 13.0055 22.3706 13.0835C22.4041 13.1614 22.4213 13.2453 22.4213 13.3301C22.4213 13.4148 22.4041 13.4987 22.3706 13.5767C22.3372 13.6546 22.2882 13.7249 22.2267 13.7832C22.1652 13.8416 22.0925 13.8869 22.013 13.9163C21.9334 13.9457 21.8488 13.9586 21.7641 13.9542V13.9542Z",
                                      fill: "#0072FF",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M21.7641 17.6827H4.55804C4.39809 17.6744 4.24741 17.6051 4.13712 17.4889C4.02682 17.3728 3.96533 17.2187 3.96533 17.0586C3.96533 16.8984 4.02682 16.7443 4.13712 16.6282C4.24741 16.5121 4.39809 16.4427 4.55804 16.4344H21.7641C21.8488 16.4301 21.9334 16.4429 22.013 16.4723C22.0925 16.5017 22.1652 16.547 22.2267 16.6054C22.2882 16.6638 22.3372 16.7341 22.3706 16.812C22.4041 16.8899 22.4213 16.9738 22.4213 17.0586C22.4213 17.1434 22.4041 17.2273 22.3706 17.3052C22.3372 17.3831 22.2882 17.4534 22.2267 17.5118C22.1652 17.5701 22.0925 17.6154 22.013 17.6448C21.9334 17.6742 21.8488 17.6871 21.7641 17.6827V17.6827Z",
                                      fill: "#0072FF",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M21.7641 21.4103H4.55804C4.39809 21.402 4.24741 21.3326 4.13712 21.2165C4.02682 21.1003 3.96533 20.9463 3.96533 20.7861C3.96533 20.6259 4.02682 20.4719 4.13712 20.3557C4.24741 20.2396 4.39809 20.1702 4.55804 20.162H21.7641C21.8488 20.1576 21.9334 20.1705 22.013 20.1999C22.0925 20.2293 22.1652 20.2745 22.2267 20.3329C22.2882 20.3913 22.3372 20.4616 22.3706 20.5395C22.4041 20.6174 22.4213 20.7013 22.4213 20.7861C22.4213 20.8709 22.4041 20.9548 22.3706 21.0327C22.3372 21.1106 22.2882 21.1809 22.2267 21.2393C22.1652 21.2977 22.0925 21.343 22.013 21.3723C21.9334 21.4017 21.8488 21.4146 21.7641 21.4103V21.4103Z",
                                      fill: "#0072FF",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M14.9777 25.1368H4.55804C4.39809 25.1285 4.24741 25.0592 4.13712 24.943C4.02682 24.8269 3.96533 24.6728 3.96533 24.5127C3.96533 24.3525 4.02682 24.1984 4.13712 24.0823C4.24741 23.9662 4.39809 23.8968 4.55804 23.8885H14.9777C15.0623 23.8842 15.147 23.8971 15.2266 23.9264C15.3061 23.9558 15.3788 24.0011 15.4403 24.0595C15.5018 24.1179 15.5508 24.1882 15.5842 24.2661C15.6177 24.344 15.6349 24.4279 15.6349 24.5127C15.6349 24.5975 15.6177 24.6814 15.5842 24.7593C15.5508 24.8372 15.5018 24.9075 15.4403 24.9659C15.3788 25.0242 15.3061 25.0695 15.2266 25.0989C15.147 25.1283 15.0623 25.1412 14.9777 25.1368V25.1368Z",
                                      fill: "#0072FF",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M30.6565 28.4336H9.8172C8.33898 28.4336 7.14062 29.6319 7.14062 31.1102V37.3233C7.14062 38.8015 8.33898 39.9998 9.8172 39.9998H30.6565C32.1347 39.9998 33.333 38.8015 33.333 37.3233V31.1102C33.333 29.6319 32.1347 28.4336 30.6565 28.4336Z",
                                      fill: "#0072FF",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M10.196 35.562V36.7736H8.94104V35.562H10.196Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M15.0291 35.5654C14.8194 35.9441 14.5037 36.2533 14.1208 36.4553C13.6901 36.6758 13.2112 36.7852 12.7275 36.7737H10.8359V31.7622H12.7275C13.2116 31.75 13.6912 31.857 14.1241 32.0738C14.5059 32.2716 14.8207 32.5778 15.0291 32.9538C15.2362 33.3579 15.3442 33.8055 15.3442 34.2596C15.3442 34.7137 15.2362 35.1612 15.0291 35.5654V35.5654ZM13.7241 35.3137C13.9779 35.0205 14.1176 34.6457 14.1176 34.2579C14.1176 33.8701 13.9779 33.4953 13.7241 33.2021C13.4211 32.936 13.0251 32.8006 12.6225 32.8255H12.0476V35.6887H12.6225C13.022 35.7113 13.4144 35.5767 13.7158 35.3137H13.7241Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M19.6918 32.0136C20.0735 32.2297 20.3888 32.5462 20.6035 32.9286C20.8233 33.335 20.9384 33.7898 20.9384 34.2519C20.9384 34.714 20.8233 35.1688 20.6035 35.5752C20.3876 35.9587 20.0713 36.2762 19.6885 36.4935C19.2969 36.7099 18.8568 36.8234 18.4094 36.8234C17.962 36.8234 17.5219 36.7099 17.1302 36.4935C16.7475 36.2762 16.4311 35.9587 16.2153 35.5752C15.9943 35.1691 15.8785 34.7142 15.8785 34.2519C15.8785 33.7896 15.9943 33.3347 16.2153 32.9286C16.4322 32.5467 16.7483 32.2305 17.1302 32.0136C17.523 31.7971 17.9642 31.6836 18.4127 31.6836C18.8612 31.6836 19.3024 31.7971 19.6952 32.0136H19.6918ZM17.4603 33.1969C17.232 33.5 17.1086 33.8691 17.1086 34.2486C17.1086 34.628 17.232 34.9971 17.4603 35.3002C17.7115 35.549 18.0508 35.6886 18.4044 35.6886C18.758 35.6886 19.0973 35.549 19.3485 35.3002C19.5776 34.9984 19.7017 34.63 19.7017 34.2511C19.7017 33.8722 19.5776 33.5037 19.3485 33.2019C19.0963 32.9537 18.7566 32.8146 18.4027 32.8146C18.0488 32.8146 17.7091 32.9537 17.4569 33.2019L17.4603 33.1969Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M25.4886 32.2155C25.9107 32.5599 26.1981 33.042 26.3002 33.5772H25.0169C24.9297 33.3552 24.7775 33.1646 24.5803 33.0305C24.373 32.8953 24.1294 32.8261 23.882 32.8322C23.7188 32.8268 23.5566 32.8592 23.408 32.9269C23.2594 32.9945 23.1284 33.0956 23.0253 33.2222C22.8127 33.5276 22.6987 33.8908 22.6987 34.263C22.6987 34.6351 22.8127 34.9983 23.0253 35.3038C23.1292 35.4291 23.2604 35.529 23.4089 35.5958C23.5574 35.6625 23.7192 35.6943 23.882 35.6888C24.1295 35.6956 24.3733 35.6263 24.5803 35.4904C24.7765 35.3587 24.9285 35.1712 25.0169 34.9521H26.3002C26.1961 35.4856 25.9091 35.966 25.4886 36.3104C25.0347 36.6568 24.4741 36.8336 23.9036 36.8104C23.4546 36.8198 23.0113 36.7081 22.6204 36.4871C22.2546 36.2748 21.9581 35.961 21.767 35.5838C21.5685 35.17 21.4655 34.7169 21.4655 34.258C21.4655 33.799 21.5685 33.346 21.767 32.9322C21.9581 32.5549 22.2546 32.2411 22.6204 32.0289C23.0113 31.8078 23.4546 31.6961 23.9036 31.7056C24.4752 31.6859 25.0357 31.8662 25.4886 32.2155V32.2155Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M30.0267 36.7732L28.9717 35.2133L28.0634 36.7732H26.6751L28.2767 34.1933L26.6251 31.7617H28.0634L29.0917 33.2717L29.9783 31.7617H31.3599L29.78 34.285L31.4666 36.7732H30.0267Z",
                                      fill: "white",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        !["docx", "png", "jpg", "jpeg", "pdf", "doc"].includes(
                          document.filename.split(".")[1]
                        )
                          ? [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "34",
                                    height: "40",
                                    viewBox: "0 0 34 40",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("g", { attrs: { opacity: "0.3" } }, [
                                    _c("path", {
                                      attrs: {
                                        opacity: "0.3",
                                        d: "M23.2783 8.20833C22.367 8.20745 21.4932 7.84515 20.8486 7.20089C20.2041 6.55663 19.8413 5.68299 19.84 4.77165V0H4.48499C3.29549 0 2.1547 0.472498 1.3136 1.3136C0.472498 2.1547 0 3.29549 0 4.48499V31.53C0 32.7195 0.472498 33.8603 1.3136 34.7014C2.1547 35.5425 3.29549 36.015 4.48499 36.015H22.9183C24.1078 36.015 25.2486 35.5425 26.0897 34.7014C26.9308 33.8603 27.4033 32.7195 27.4033 31.53V8.20833H23.2783Z",
                                        fill: "#00C650",
                                      },
                                    }),
                                  ]),
                                  _c("path", {
                                    attrs: {
                                      d: "M27.4032 8.20833H23.2782C22.3668 8.20745 21.493 7.84515 20.8485 7.20089C20.2039 6.55663 19.8412 5.68299 19.8398 4.77165V0L27.4032 8.20833Z",
                                      fill: "#00C650",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M30.6563 28.4333H9.81632C8.33804 28.4333 7.13965 29.6317 7.13965 31.11V37.3233C7.13965 38.8016 8.33804 40 9.81632 40H30.6563C32.1346 40 33.333 38.8016 33.333 37.3233V31.11C33.333 29.6317 32.1346 28.4333 30.6563 28.4333Z",
                                      fill: "#00C650",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M14.2754 34.0863C14.2754 34.5737 14.183 34.9885 13.9982 35.3304C13.8149 35.6724 13.5646 35.9336 13.2473 36.1141C12.9316 36.293 12.5765 36.3825 12.1822 36.3825C11.7849 36.3825 11.4284 36.2923 11.1126 36.1119C10.7968 35.9314 10.5473 35.6702 10.3639 35.3283C10.1805 34.9863 10.0889 34.5723 10.0889 34.0863C10.0889 33.5988 10.1805 33.184 10.3639 32.8421C10.5473 32.5001 10.7968 32.2396 11.1126 32.0606C11.4284 31.8802 11.7849 31.79 12.1822 31.79C12.5765 31.79 12.9316 31.8802 13.2473 32.0606C13.5646 32.2396 13.8149 32.5001 13.9982 32.8421C14.183 33.184 14.2754 33.5988 14.2754 34.0863ZM13.3172 34.0863C13.3172 33.7705 13.2699 33.5042 13.1753 33.2874C13.0822 33.0705 12.9505 32.9061 12.7802 32.7941C12.61 32.682 12.4106 32.626 12.1822 32.626C11.9537 32.626 11.7543 32.682 11.5841 32.7941C11.4138 32.9061 11.2814 33.0705 11.1868 33.2874C11.0937 33.5042 11.0471 33.7705 11.0471 34.0863C11.0471 34.402 11.0937 34.6683 11.1868 34.8852C11.2814 35.102 11.4138 35.2664 11.5841 35.3785C11.7543 35.4905 11.9537 35.5465 12.1822 35.5465C12.4106 35.5465 12.61 35.4905 12.7802 35.3785C12.9505 35.2664 13.0822 35.102 13.1753 34.8852C13.2699 34.6683 13.3172 34.402 13.3172 34.0863Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M14.6012 32.6303V31.8511H18.2726V32.6303H16.904V36.3214H15.9698V32.6303H14.6012Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M18.8773 36.3214V31.8511H19.8224V33.6955H21.7411V31.8511H22.684V36.3214H21.7411V34.4748H19.8224V36.3214H18.8773Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M23.4633 36.3214V31.8511H26.4755V32.6303H24.4084V33.6955H26.3206V34.4748H24.4084V35.5422H26.4843V36.3214H23.4633Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M27.227 36.3214V31.8511H28.9906C29.3282 31.8511 29.6164 31.9115 29.855 32.0323C30.0951 32.1516 30.2777 32.3211 30.4029 32.5409C30.5295 32.7591 30.5928 33.016 30.5928 33.3114C30.5928 33.6082 30.5288 33.8636 30.4007 34.0775C30.2727 34.29 30.0871 34.453 29.8441 34.5665C29.6025 34.68 29.31 34.7367 28.9666 34.7367H27.7857V33.9771H28.8138C28.9943 33.9771 29.1442 33.9524 29.2635 33.9029C29.3828 33.8534 29.4716 33.7792 29.5298 33.6803C29.5894 33.5813 29.6193 33.4583 29.6193 33.3114C29.6193 33.1629 29.5894 33.0378 29.5298 32.9359C29.4716 32.8341 29.3821 32.7569 29.2613 32.7046C29.142 32.6507 28.9914 32.6238 28.8095 32.6238H28.1721V36.3214H27.227ZM29.6411 34.2871L30.7521 36.3214H29.7088L28.6217 34.2871H29.6411Z",
                                      fill: "white",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M9.065 17.695H11.5485C12.2315 17.695 12.7903 17.1502 12.7903 16.4843V14.0629C12.7903 13.397 12.2315 12.8522 11.5485 12.8522H9.065C8.38203 12.8522 7.82324 13.397 7.82324 14.0629V16.4843C7.82324 17.1502 8.38203 17.695 9.065 17.695ZM9.065 23.7486H11.5485C12.2315 23.7486 12.7903 23.2038 12.7903 22.5379V20.1165C12.7903 19.4506 12.2315 18.9057 11.5485 18.9057H9.065C8.38203 18.9057 7.82324 19.4506 7.82324 20.1165V22.5379C7.82324 23.2038 8.38203 23.7486 9.065 23.7486ZM14.032 14.0629V16.4843C14.032 17.1502 14.5908 17.695 15.2738 17.695H17.7573C18.4403 17.695 18.9991 17.1502 18.9991 16.4843V14.0629C18.9991 13.397 18.4403 12.8522 17.7573 12.8522H15.2738C14.5908 12.8522 14.032 13.397 14.032 14.0629ZM15.2738 23.7486H17.7573C18.4403 23.7486 18.9991 23.2038 18.9991 22.5379V20.1165C18.9991 19.4506 18.4403 18.9057 17.7573 18.9057H15.2738C14.5908 18.9057 14.032 19.4506 14.032 20.1165V22.5379C14.032 23.2038 14.5908 23.7486 15.2738 23.7486Z",
                                      fill: "#00C650",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "flex flex-col" }, [
                      _c("div", { staticClass: "fileNameRow" }, [
                        _vm._v(_vm._s(document.filename)),
                      ]),
                      _c(
                        "div",
                        { staticClass: "text-xs text-storm-gray leading-3" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(document.created_at)) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "ml-auto flex justify-center items-center",
                      },
                      [
                        _c("DocumentProvider", {
                          attrs: {
                            document: document,
                            currentUserRole: _vm.currentUser.role,
                          },
                          on: {
                            documentDeleted: function ($event) {
                              return _vm.$emit("documentDeleted")
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ download, processing }) {
                                  return [
                                    _c(
                                      "Processing",
                                      { attrs: { processing: processing } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex w-full items-center",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "mr-1 cursor-pointer flex",
                                                on: { click: download },
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      width: "14",
                                                      height: "15",
                                                      viewBox: "0 0 14 15",
                                                      fill: "none",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M6.90156 9.8252C6.91326 9.84014 6.92819 9.85222 6.94525 9.86053C6.96231 9.86884 6.98103 9.87316 7 9.87316C7.01897 9.87316 7.03769 9.86884 7.05475 9.86053C7.0718 9.85222 7.08674 9.84014 7.09844 9.8252L8.84844 7.61113C8.9125 7.52988 8.85469 7.40957 8.75 7.40957H7.59219V2.12207C7.59219 2.05332 7.53594 1.99707 7.46719 1.99707H6.52969C6.46094 1.99707 6.40469 2.05332 6.40469 2.12207V7.40801H5.25C5.14531 7.40801 5.0875 7.52832 5.15156 7.60957L6.90156 9.8252ZM12.7188 9.27832H11.7812C11.7125 9.27832 11.6562 9.33457 11.6562 9.40332V11.8096H2.34375V9.40332C2.34375 9.33457 2.2875 9.27832 2.21875 9.27832H1.28125C1.2125 9.27832 1.15625 9.33457 1.15625 9.40332V12.4971C1.15625 12.7736 1.37969 12.9971 1.65625 12.9971H12.3438C12.6203 12.9971 12.8438 12.7736 12.8438 12.4971V9.40332C12.8438 9.33457 12.7875 9.27832 12.7188 9.27832Z",
                                                        fill: "#717986",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }